import { gsap } from "gsap";

export default class Light {
    constructor() {
        this.lights = [];
        this.init();
    }

    init() {
        this.setup();
        this.setupNoclip();

        if (this.lights.length > 0) {
            this.setEvents();
        }
    }

    setup() {
        const lightSection = [...document.querySelectorAll(".js-light_section")];

        lightSection.forEach((section, index) => {
            const light = document.createElement("div");
            const obj = document.createElement("div");
            light.classList.add("l-light");
            obj.classList.add("obj");
            light.appendChild(obj);
            section.prepend(light);

            const colorType = section.getAttribute("data-light");
            light.setAttribute("data-color", colorType);
            light.setAttribute("data-index", index);

            this.lights.push(light);
        });
    }

    setupNoclip() {
        const lightSection = [...document.querySelectorAll(".js-light_section-noclip")];

        lightSection.forEach((section, index) => {
            const light = document.createElement("div");
            const obj = document.createElement("div");
            light.classList.add("l-light");
            obj.classList.add("obj");
            light.appendChild(obj);
            section.prepend(light);

            const colorType = section.getAttribute("data-light");
            light.setAttribute("data-color", colorType);
            light.setAttribute("data-index", index);
            light.setAttribute("data-disable", "1");
            this.lights.push(light);

            section.addEventListener("mouseenter", () => {
                light.removeAttribute("data-disable");
            });

            section.addEventListener("mouseleave", () => {
                light.setAttribute("data-disable", "1");
            });
        });
    }

    setEvents() {
        window.addEventListener("mousemove", (e) => {
            const w = this.lights[0].offsetWidth;
            const xPos = e.clientX - w / 2;
            const yPos = e.clientY - w / 2;

            this.lights.forEach((light) => {
                gsap.to(light, { x: xPos, y: yPos, duration: 0.6 });
            });
        });
    }
}
